//#region src/api/error.ts
var FragnoApiError = class extends Error {
	#status;
	#code;
	constructor({ message, code }, status) {
		super(message);
		this.name = "FragnoApiError";
		this.#status = status;
		this.#code = code;
	}
	get status() {
		return this.#status;
	}
	get code() {
		return this.#code;
	}
	toResponse() {
		return Response.json({
			message: this.message,
			code: this.code
		}, { status: this.status });
	}
};
var FragnoApiValidationError = class extends FragnoApiError {
	#issues;
	constructor(message, issues) {
		super({
			message,
			code: "FRAGNO_VALIDATION_ERROR"
		}, 400);
		this.name = "FragnoApiValidationError";
		this.#issues = issues;
	}
	get issues() {
		return this.#issues;
	}
	toResponse() {
		return Response.json({
			message: this.message,
			issues: this.#issues,
			code: this.code
		}, { status: this.status });
	}
};

//#endregion
export { FragnoApiError, FragnoApiValidationError };
//# sourceMappingURL=error.js.map